import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const getResponseOfferedListing = (requestIdInt, responseIdInt) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData();
        fdd.append('requestIdInt', requestIdInt);
        fdd.append('responseIdInt', responseIdInt);

        axios({
          method : "POST",
          url :  api_url + "/GetResponsePackage",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const uploadInterest = (listingCategory, listingId, listingOwnerId, userId, title) => {
    return new Promise((resolve, reject) => {
        var fdd = new FormData();
        fdd.append('listingCategory', listingCategory); 
        fdd.append('listingId', listingId);
        fdd.append('listingOwnerId', listingOwnerId);
        fdd.append('fromUserId', userId);
        fdd.append('title', title);

        axios({
          method : "POST",
          url :  api_url + "/public/UploadInterest",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const uploadListingImages = (userId, listingId, file, fileType, listingCategory, awslistingCategory) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('listingId', listingId);
        fdd.append('file', file);
        fdd.append('fileType', fileType);
        fdd.append('listingCategory', "Fitness Trainer");
        fdd.append('awslistingCategory', "Fitness")

        axios({
          method : "POST",
          url :  api_url + "/UploadListingImages",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}
